import { useState, useEffect } from "react";
import { useCreateTemplatesMessage } from "../../../features/partner/rcs/hooks/useFetchTemplatesMessage";
import { useFormikMessageTemplate } from "../../../features/partner/rcs/hooks/useFormikMessageTemplate";
import { errorLabels } from "../../../utils/helpers";
import { ErrorMessage } from "../../../utils/toastify";
export const useSaveTemplate = (data, onClose) => {
  const [reset, setReset] = useState(false);
  const { mutate: createTemplate, isLoading } = useCreateTemplatesMessage(true);

  const formik = useFormikMessageTemplate({
    onSubmit: async (values) => {
      await createTemplate(values);
    },
  });

  useEffect(() => {
    if (!data) return;
    formik.setValues({
      status: true,
      step: data?.step,
      fallback: data?.fallback,
      parameters: data?.parameters,
      rcsmessage: data?.rcsmessage,
      buttonQuickReplies: data?.buttonQuickReplies,
      buttonActions: data?.buttonActions,
      title_rcs_message: data?.title_rcs_message,
      imageUrl: data?.imageUrl,
      thumbnail_url: data?.thumbnail_url,
      height: data?.height,
      carrousel: data?.carrousel,
      cardOrientation: data?.cardOrientation,
    });
  }, [data]);

  const _validate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }

      await formik.submitForm();

      await handleReset();
      onClose();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  const handleReset = () => {
    formik.resetForm();
    setReset(true);
  };

  return {
    formik,
    isLoading,
    _validate,
    reset,
    handleReset,
  };
};
